// router/empresa/sucursal/routes.js

import dashboard from './dashboard.routes'
import alertas from './alertas.routes'
import compras from './compras.routes'
import ventas from './ventas.routes'
import productos from './productos.routes'
import caja from './caja.routes'
import egresos from './egresos.routes'
import contabilidad from './contabilidad.routes'
import reportes from './reportes.routes'
import configuracion from './configuracion.routes'
import categorias from './categorias.routes'

export default [
  ...dashboard,
  ...alertas,
  ...compras,
  ...ventas,
  ...productos, 
  ...caja,
  ...egresos,
  ...contabilidad,
  ...reportes,
  ...configuracion,
  ...categorias
]
